<template>
  <div class="ShareDialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="560px"
      custom-class="share_dialog"
      :before-close="handleClose"
    >
      <div class="share_title">发布分享</div>
      <el-form ref="shareForm" :model="form" :rules="rules" label-position="top">
        <el-form-item label="分享分类" prop="category">
          <el-select v-model="form.category" placeholder="请选择分类" style="width: 100%">
            <el-option
              v-for="tab in categoryOptions"
              :key="tab.key"
              :label="tab.label"
              :value="tab.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分享内容" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="6"
            maxlength="500"
            show-word-limit
            placeholder="分享你的经验、干货或观点..."
          ></el-input>
        </el-form-item>
        <el-form-item label="标签（最多3个）">
          <div class="tag_row">
            <el-tag
              v-for="tag in form.tags"
              :key="tag"
              class="share_tag"
              closable
              @close="removeTag(tag)"
            >{{ tag }}</el-tag>
            <el-input
              v-if="tagInputVisible"
              ref="tagInput"
              v-model="tagInputValue"
              size="small"
              class="tag_input"
              maxlength="8"
              @keyup.enter.native="addTag"
              @blur="addTag"
            ></el-input>
            <el-button
              v-else
              size="small"
              class="tag_add_btn"
              :disabled="form.tags.length >= 3"
              @click="showTagInput"
            >+ 添加标签</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div class="share_footer">
        <el-button class="share_cancel" @click="handleClose">取 消</el-button>
        <el-button class="share_submit" :loading="loading" @click="handleSubmit">发 布</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { forumCategoryTabs } from "@/data/newsData";
import { saveForumPostApi } from "@/api/index";

export default {
  name: "ShareDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      tagInputVisible: false,
      tagInputValue: "",
      form: {
        category: "",
        content: "",
        tags: [],
      },
      rules: {
        category: [{ required: true, message: "请选择分享分类", trigger: "change" }],
        content: [{ required: true, message: "请输入分享内容", trigger: "blur" }],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    loginPromptSeq() {
      return this.$store.getters["auth/loginPromptSeq"];
    },
    //分类选项去掉"全部"
    categoryOptions() {
      return forumCategoryTabs.filter((tab) => tab.key !== "all");
    },
  },
  watch: {
    //每次打开清空上一轮内容
    visible(val) {
      if (val) {
        this.form.category = "";
        this.form.content = "";
        this.form.tags = [];
        this.tagInputVisible = false;
        this.tagInputValue = "";
        this.$nextTick(() => {
          if (this.$refs.shareForm) this.$refs.shareForm.clearValidate();
        });
      }
    },
    loginPromptSeq() {
      if (this.visible) this.handleClose();
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick(() => {
        this.$refs.tagInput.focus();
      });
    },
    addTag() {
      const value = this.tagInputValue.trim();
      if (value && !this.form.tags.includes(value)) {
        this.form.tags.push(value);
      }
      this.tagInputVisible = false;
      this.tagInputValue = "";
    },
    removeTag(tag) {
      this.form.tags = this.form.tags.filter((t) => t !== tag);
    },
    handleSubmit() {
      this.$refs.shareForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        saveForumPostApi({
          category: this.form.category,
          content: this.form.content,
          tags: [...this.form.tags],
        }).then((res) => {
          this.loading = false;
          if (res.code !== 0) {
            this.$message.error(res.msg || "发布失败");
            return;
          }
          this.$message.success(res.msg || "发布成功");
          this.$emit("success", res.data || {
            category: this.form.category,
            content: this.form.content,
            tags: [...this.form.tags],
          });
          this.handleClose();
        }).catch((err) => {
          this.loading = false;
          this.$message.error((err && err.msg) || "发布失败");
        });
      });
    },
  },
};
</script>

<style scoped>
.ShareDialog >>> .share_dialog {
  border-radius: 8px;
}

.ShareDialog >>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ShareDialog >>> .share_dialog {
  margin: 0 !important;
}

.ShareDialog >>> .share_dialog .el-dialog__header {
  padding: 0;
}

.ShareDialog >>> .share_dialog .el-dialog__body {
  padding: 28px 32px 24px;
}

.share_title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  padding-bottom: 16px;
}

.ShareDialog >>> .el-form-item {
  margin-bottom: 16px;
}

.ShareDialog >>> .el-form--label-top .el-form-item__label {
  padding-bottom: 4px;
  line-height: 20px;
}

.tag_row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.share_tag {
  background: #ecf5ff;
  border-color: #ecf5ff;
  color: #409eff;
}

.tag_input {
  width: 100px;
}

.tag_add_btn {
  border-style: dashed;
}

.share_footer {
  text-align: center;
  padding-top: 8px;
}

.share_cancel {
  width: 110px;
  height: 40px;
  border-radius: 8px;
}

.share_submit {
  width: 110px;
  height: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #2968bd, #1b63a7);
  border: none;
  border-radius: 8px;
  margin-left: 16px;
}

.share_submit:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}
</style>


// WEBPACK FOOTER //
// src/views/components/ShareDialog.vue